import { lazy } from 'react';

const ReportsListPage = lazy(() => import('./pages/list'));
const ReportDetailPage = lazy(() => import('./pages/details'));

export const reportsRoutes = {
    path: 'reports',
    children: [
        { element: <ReportsListPage />, index: true },
        { path: ':id', element: <ReportDetailPage /> },
    ],
};
